"use client";

import Header from "../(landing)/(components)/Header";
import Footer from "../(landing)/(components)/Footer";

export default function RootLayout({ children }) {
  return (
    <>
      <Header />

      {children}
      <Footer />
    </>
  );
}
